const rootElement = document.getElementById('root');
const rootProps = rootElement.dataset;

export {
  rootProps,
  rootElement
}
